import React from 'react';

export function About() {
  return <article>
    <h1>About</h1>
    <section>
      Hey, I'm kirilloid. I play and <a href="https://sourcegaming.info/2017/07/21/an-introduction-to-video-game-data-mining/">data-mine</a> Valheim. BTW don't just google data-mining in general, specifically in games the term has slightly different meaning.<br />
      I work on this project in my free-time. It's open-source, you can find code on <a href="https://github.com/kirilloid/valheim">GitHub</a>.<br />
      If you have any questions, suggestions or other comments, you can find me on <a href="https://discord.gg/valheim">official Valheim Discord server</a> by the same nickname: <code>kirilloid#8246</code>.
    </section>
  </article>
}
